import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { Gallery } from "../components/Gallery";
import { useSeo } from "../hooks/useSeo";
import { IMG } from "../data/content";

/* ---------- Gallery data ----------
   Bilder 1-5 geliefert; restliche Slots sind Platzhalter bis zur Nachlieferung. */
const AUSSTELLUNG_GALERIE = {
  label: "Ausstellungs-Galerie zu diversen Fussböden",
  images: [
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/a6vm4twr_Ausstellung-Fussboden-Blum-1.webp", alt: "Ausstellung Fussboden Blum – verlegte Landhausdiele mit Musterständen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/krvqumw0_Ausstellung-Fussboden-Blum-2.webp", alt: "Ausstellung Fussboden Blum – Musterstände und Beratungsecke" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/y6csrkbv_Ausstellung-Fussboden-Blum-3.webp", alt: "Ausstellung Fussboden Blum – Verkaufstheke mit JOKA-Musterboxen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/pfxmauc0_Ausstellung-Fussboden-Blum-4.webp", alt: "Ausstellung Fussboden Blum – heller Beratungsbereich mit Sitzgelegenheiten" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/0x1syzfi_Ausstellung-Fussboden-Blum-5.webp", alt: "Ausstellung Fussboden Blum – Musterschubladen mit Bodenbelägen in vielen Dekoren" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/zeex4ydk_Ausstellung-Fussboden-Blum-6.webp", alt: "Ausstellung Fussboden Blum – weiträumiger Ausstellungsbereich mit Holzdecke" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/i40hc6w4_Ausstellung-Fussboden-Blum-7.webp", alt: "Ausstellung Fussboden Blum – Musterschubfächer mit Designbelag-Dekoren" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/bm9hletw_Ausstellung-Fussboden-Blum-8.webp", alt: "Ausstellung Fussboden Blum – JOKA Musterbox mit Bodendekoren" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/7skdsp1x_Ausstellung-Fussboden-Blum-9.webp", alt: "Ausstellung Fussboden Blum – Designboden-Paket mit Verlegewerkzeug auf Parkett" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/kg3nqhp8_Ausstellung-Fussboden-Blum-10.webp", alt: "Ausstellung Fussboden Blum – Firmengebäude in Mittelkalbach von außen" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/kg7kgmw1_Ausstellung-Fussboden-Blum-11.webp", alt: "Ausstellung Fussboden Blum – Musterständer von objectflor und enia" },
    { src: "https://customer-assets-0z36b82j.emergentagent.net/job_fussboden-modern/artifacts/uzqaxnrm_Ausstellung-Fussboden-Blum-12.webp", alt: "Ausstellung Fussboden Blum – Empfangsbereich mit Parkett-Star-Roll-up und Jubiläumsurkunde" },
  ],
};

const AusstellungHero = () => (
  <section data-testid="ausstellung-hero" className="relative min-h-[68vh] flex items-end overflow-hidden">
    <img
      src={IMG.ausstellungHeader}
      alt="Ausstellung von Fussboden Blum mit Teppich- und Bodenmustern"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B30]/95 via-[#2B2B30]/55 to-[#2B2B30]/30" />
    <div className="container-blum relative z-10 pb-16 pt-40">
      <Reveal>
        <p data-testid="ausstellung-hero-script" className="font-script text-3xl lg:text-4xl text-[#D7C4B1]">
          Unsere Ausstellung in Kalbach
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight mt-3 max-w-3xl">
          Lassen Sie sich inspirieren!
        </h1>
        <p className="text-lg text-white/85 mt-5 max-w-2xl leading-relaxed">
          Auf 150 Quadratmetern: die neuesten Boden-Trends zum Ansehen, Anfassen
          und Vergleichen – mit persönlicher Beratung durch unser Meister-Team.
        </p>
      </Reveal>
    </div>
  </section>
);

const AusstellungText = () => (
  <section data-testid="ausstellung-text" className="py-20 lg:py-28">
    <div className="container-blum max-w-3xl">
      <Reveal><p className="overline">Vor Ort in Mittelkalbach</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
          Unsere Fussboden-Ausstellung in Kalbach
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="text-[#6B6B73] text-lg leading-relaxed mt-6 space-y-5">
          <p>
            Sie möchten Ihr Zuhause oder Ihre gewerblichen Räume mit neuen Böden ausstatten und
            haben Fragen zu Stil, Material, Verlegetechniken oder dergleichen? Kein Problem – unser
            fachkundiges Team steht Ihnen mit Rat und Tat zur Seite. Wir laden Sie herzlich ein,
            sich in unserer umfangreichen Ausstellung umzusehen und uns alle Fragen zu stellen, die
            Sie auf dem Herzen haben.
          </p>
          <p>
            In unserer weiträumigen Ausstellung stellen wir Ihnen auf 150 Quadratmetern gern die
            neuesten Boden-Trends vor und beraten Sie zur stilsicheren Gestaltung Ihres Zuhauses.
            Klicken Sie sich doch schon einmal durch unsere Bildergalerie und gewinnen Sie einen
            ersten Eindruck von unseren Produkten!
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

const BeratungText = () => (
  <section data-testid="ausstellung-beratung" className="py-20 lg:py-28 bg-white border-t border-[#E5E0D8]">
    <div className="container-blum max-w-3xl">
      <Reveal><p className="overline">Hausbesuch</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
          Beratung bei Ihnen zu Hause
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="text-[#6B6B73] text-lg leading-relaxed mt-6 space-y-5">
          <p>
            Firmenchef Michael Blum kümmert sich mit seinem fundierten Fachwissen und seiner
            langjährigen Erfahrung um die Erstberatung unserer Kunden vor Ort. Die Beratung bei
            Ihnen zu Hause oder auf der Baustelle ist ein sehr wichtiger Bestandteil unserer
            Serviceleistung und soll Sie bei der Wahl des richtigen Unterbodens und des Oberbelages
            unterstützen. Unsere professionellen, kreativen Ratschläge und die individuelle Beratung
            spiegeln sich in der Ausführung und Ästhetik des fertigen Fußbodens wider.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default function Ausstellung() {
  useSeo(
    "Fussboden-Ausstellung in Kalbach",
    "Fussboden-Ausstellung bei Fussboden Blum in Kalbach - lassen Sie sich inspirieren."
  );

  return (
    <div data-testid="ausstellung-page">
      <Navbar />
      <main>
        <AusstellungHero />
        <AusstellungText />
        <Gallery
          gallery={AUSSTELLUNG_GALERIE}
          gi={1}
          testidPrefix="ausstellung"
          heading="Ausstellungs-Galerie zu diversen Fussböden"
          overline="Ausstellung"
        />
        <BeratungText />
      </main>
      <Footer />
    </div>
  );
}
